'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getEndpoint = require('../get-endpoint');

var _getEndpoint2 = _interopRequireDefault(_getEndpoint);

var _config = require('../config');

var _model = require('./model');

var _model2 = _interopRequireDefault(_model);

var _dataProvider = require('../data-provider');

var _dataProvider2 = _interopRequireDefault(_dataProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the language data
 * @param {LanguageDataParamsType} params Get Language data parameters
 * @returns {Promise<LanguageMapType>} A list of languages
 */
exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(params) {
        var _params$lang, lang, _params$product, product, tunnel, endpoint, proxyAgent, data;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _params$lang = params.lang, lang = _params$lang === undefined ? 'en-gb' : _params$lang, _params$product = params.product, product = _params$product === undefined ? 'sportsbook' : _params$product, tunnel = params.tunnel;
                        endpoint = (0, _getEndpoint2.default)('squiz', '/' + product + '/' + lang + '/admin/esi/header-json-components/languages');
                        proxyAgent = (0, _config.getProxy)('squiz');
                        _context.next = 5;
                        return (0, _dataProvider2.default)(endpoint, tunnel, {
                            agent: proxyAgent
                        });

                    case 5:
                        data = _context.sent;
                        return _context.abrupt('return', (0, _model2.default)(data));

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function getLanguagesData(_x) {
        return _ref.apply(this, arguments);
    }

    return getLanguagesData;
}();
//# sourceMappingURL=languages.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/languages/languages.js
// module id = 449
// module chunks = 0